import moment from "moment";
//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim
//! moment.js locale configuration
moment.updateLocale("en", {
  relativeTime: {
    m: "1 minute",
    h: "1 hour",
    d: "1 day",
    M: "1 month",
    y: "1 year"
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW4uanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9wbHVnaW5zL2JhbnphL21vbWVudC9sb2NhbGUvZW4uanMiXSwic291cmNlc0NvbnRlbnQiOlsiLy8hIG1vbWVudC5qcyBsb2NhbGUgY29uZmlndXJhdGlvblxuLy8hIGxvY2FsZSA6IEVuZ2xpc2ggKFVuaXRlZCBLaW5nZG9tKSBbZW4tZ2JdXG4vLyEgYXV0aG9yIDogQ2hyaXMgR2VkcmltIDogaHR0cHM6Ly9naXRodWIuY29tL2NocmlzZ2VkcmltXG5cbmltcG9ydCBtb21lbnQgZnJvbSBcIm1vbWVudFwiO1xuXG4vLyEgbW9tZW50LmpzIGxvY2FsZSBjb25maWd1cmF0aW9uXG5cbmV4cG9ydCBkZWZhdWx0IG1vbWVudC51cGRhdGVMb2NhbGUoXCJlblwiLCB7XG5cdHJlbGF0aXZlVGltZToge1xuXHRcdG06IFwiMSBtaW51dGVcIixcblx0XHRoOiBcIjEgaG91clwiLFxuXHRcdGQ6IFwiMSBkYXlcIixcblx0XHRNOiBcIjEgbW9udGhcIixcblx0XHR5OiBcIjEgeWVhclwiLFxuXHR9LFxufSk7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBO0FBQ0E7QUFDQTtBQUlBO0FBRWUsT0FBTyxhQUFhLE1BQU07QUFBQSxFQUN4QyxjQUFjO0FBQUEsSUFDYixHQUFHO0FBQUEsSUFDSCxHQUFHO0FBQUEsSUFDSCxHQUFHO0FBQUEsSUFDSCxHQUFHO0FBQUEsSUFDSCxHQUFHO0FBQUEsRUFDSDtBQUNGLENBQUM7In0=
